export const environment = {
  production: true,
  devBaseUrl: 'api.cms-dv2.earthquakebracebolt.com'
};
